const { adminCall } = require("./_utils");

module.exports = {
  init: data => adminCall("chat.init", data),
  post: data => adminCall("chat.post", data)
}
